/**
 * Documenti legali pubblici: sono quelli linkati in fondo al sito place2be.it,
 * non le pagine /terms e /privacy dell'app. Unica fonte per login e primo accesso,
 * cosi' non si aggiornano in due posti diversi.
 *
 * Il sito li pubblica in italiano alla radice e in inglese sotto /en, con lo
 * stesso slug. Qualunque lingua diversa dall'inglese apre la versione italiana.
 */
export type LegalDocument = 'terms' | 'privacy';

const LEGAL_SLUGS: Record<LegalDocument, string> = {
  terms: 'termini-e-condizioni',
  privacy: 'informativa-privacy',
};

export const getLegalUrl = (doc: LegalDocument, language?: string): string => {
  const prefix = language?.slice(0, 2) === 'en' ? '/en' : '';
  return `https://www.place2be.it${prefix}/${LEGAL_SLUGS[doc]}`;
};
